define("auth/components/o-auth", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/service", "later/utils/fetch", "shared/utils/redirect", "later/utils/constants"], function (_exports, _component, _templateFactory, _component2, _object, _service, _fetch3, _redirect, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _authorizationUrl, _fetch;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }

  function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }

  function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{!-- Page Content --}}
  <div class="tSU--container">
    <div class="tSU--container__row">
      <div class="tSU--card">
        {{!-- Title --}}
        {{#if this.isError}}
          <h1 class="tSU--card__title u--m__b__lg">{{t "authorization.oauth.modal.error_header"}}</h1>
        {{else if @appDetails}}
          <h1 class="tSU--card__title u--m__b__lg">{{t "authorization.oauth.modal.header" appName=this.appName}}</h1>
        {{/if}}
        {{!-- Content: List --}}
        {{#if this.isError}}
          <p class="u--text--bold">{{this.errorDescription}}</p>
        {{else if this.isSsoOnly}}
          <p class="u--text--bold">{{t "authorization.oauth.modal.body.text_sso_only" appName=this.appName email=this.currentUser.email}}</p>
        {{else}}
          <p class="u--text--bold">{{t "authorization.oauth.modal.body.text"}}</p>
          <ul class="u--p__l__lg u--m__b">
            {{#each this.requestedScopes as |requestedScope|}}
              <li>{{t (concat "authorization.oauth.modal.body.requested_scope." requestedScope)}}</li>
            {{/each}}
          </ul>
        {{/if}}
        {{!-- Buttons --}}
        {{#unless this.isError}}
          <Shared::Ui::Button
            @class="o--btn o--btn--block u--m__t__lg"
            @type="primary"
            @onClick={{this.authorizeOAuth}}
            @text={{t "authorization.oauth.modal.button.authorize"}}
          />
          <Shared::Ui::Button
            @class="o--btn o--btn--block u--m__t"
            @type="outline"
            @onClick={{this.denyOAuth}}
            @text={{t "authorization.oauth.modal.button.deny"}}
          />
        {{/unless}}
      </div>
    </div>
  </div>
  
  */
  {
    "id": "RKf9SEpa",
    "block": "[[[10,0],[14,0,\"tSU--container\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"tSU--container__row\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"tSU--card\"],[12],[1,\"\\n\"],[41,[30,0,[\"isError\"]],[[[1,\"        \"],[10,\"h1\"],[14,0,\"tSU--card__title u--m__b__lg\"],[12],[1,[28,[35,1],[\"authorization.oauth.modal.error_header\"],null]],[13],[1,\"\\n\"]],[]],[[[41,[30,1],[[[1,\"        \"],[10,\"h1\"],[14,0,\"tSU--card__title u--m__b__lg\"],[12],[1,[28,[35,1],[\"authorization.oauth.modal.header\"],[[\"appName\"],[[30,0,[\"appName\"]]]]]],[13],[1,\"\\n      \"]],[]],null]],[]]],[41,[30,0,[\"isError\"]],[[[1,\"        \"],[10,2],[14,0,\"u--text--bold\"],[12],[1,[30,0,[\"errorDescription\"]]],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isSsoOnly\"]],[[[1,\"        \"],[10,2],[14,0,\"u--text--bold\"],[12],[1,[28,[35,1],[\"authorization.oauth.modal.body.text_sso_only\"],[[\"appName\",\"email\"],[[30,0,[\"appName\"]],[30,0,[\"currentUser\",\"email\"]]]]]],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,2],[14,0,\"u--text--bold\"],[12],[1,[28,[35,1],[\"authorization.oauth.modal.body.text\"],null]],[13],[1,\"\\n        \"],[10,\"ul\"],[14,0,\"u--p__l__lg u--m__b\"],[12],[1,\"\\n\"],[42,[28,[37,3],[[28,[37,3],[[30,0,[\"requestedScopes\"]]],null]],null],null,[[[1,\"            \"],[10,\"li\"],[12],[1,[28,[35,1],[[28,[37,4],[\"authorization.oauth.modal.body.requested_scope.\",[30,2]],null]],null]],[13],[1,\"\\n\"]],[2]],null],[1,\"        \"],[13],[1,\"\\n      \"]],[]]]],[]]],[41,[51,[30,0,[\"isError\"]]],[[[1,\"        \"],[8,[39,6],null,[[\"@class\",\"@type\",\"@onClick\",\"@text\"],[\"o--btn o--btn--block u--m__t__lg\",\"primary\",[30,0,[\"authorizeOAuth\"]],[28,[37,1],[\"authorization.oauth.modal.button.authorize\"],null]]],null],[1,\"\\n        \"],[8,[39,6],null,[[\"@class\",\"@type\",\"@onClick\",\"@text\"],[\"o--btn o--btn--block u--m__t\",\"outline\",[30,0,[\"denyOAuth\"]],[28,[37,1],[\"authorization.oauth.modal.button.deny\"],null]]],null],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"@appDetails\",\"requestedScope\"],false,[\"if\",\"t\",\"each\",\"-track-array\",\"concat\",\"unless\",\"shared/ui/button\"]]",
    "moduleName": "auth/components/o-auth.hbs",
    "isStrictMode": false
  });

  let OAuthComponent = (_class = (_authorizationUrl = /*#__PURE__*/new WeakMap(), _fetch = /*#__PURE__*/new WeakSet(), class OAuthComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _classPrivateMethodInitSpec(this, _fetch);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _classPrivateFieldInitSpec(this, _authorizationUrl, {
        writable: true,
        value: '/oauth/authorize'
      });
    }

    get appName() {
      var _this$args$appDetails;

      return (_this$args$appDetails = this.args.appDetails.name) !== null && _this$args$appDetails !== void 0 ? _this$args$appDetails : '';
    }

    get currentUser() {
      return this.auth.currentUserModel;
    }

    get isError() {
      return this.args.payload.error;
    }

    get errorDescription() {
      return this.args.payload.error_description;
    }

    get requestedScopes() {
      var _this$args$payload$sc;

      if (!this.args.payload.scope) {
        return [];
      }

      return (_this$args$payload$sc = this.args.payload.scope) === null || _this$args$payload$sc === void 0 ? void 0 : _this$args$payload$sc.split(',');
    }

    get isSsoOnly() {
      return this.requestedScopes.length === 1 && this.requestedScopes[0] === 'sso';
    }

    authorizeOAuth() {
      _classPrivateMethodGet(this, _fetch, _fetch2).call(this, _constants.HttpMethod.Post, this.args.payload);
    }

    denyOAuth() {
      _classPrivateMethodGet(this, _fetch, _fetch2).call(this, _constants.HttpMethod.Delete, this.args.payload);
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "authorizeOAuth", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "authorizeOAuth"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "denyOAuth", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "denyOAuth"), _class.prototype)), _class);
  _exports.default = OAuthComponent;

  async function _fetch2(method, payload) {
    try {
      const response = await (0, _fetch3.fetch)(_classPrivateFieldGet(this, _authorizationUrl), {
        method,
        body: payload
      });

      if (response.redirect_uri) {
        (0, _redirect.default)(response.redirect_uri);
      }
    } catch (error) {
      var _error$description;

      if ((_error$description = error.description) !== null && _error$description !== void 0 && _error$description.redirect_uri) {
        (0, _redirect.default)(error.description.redirect_uri);
      }
    }
  }

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, OAuthComponent);
});